module.exports = __webpack_public_path__ + "static/media/Appointment-slip-72269673366740.2a4d255f.pdf";